module.exports = __webpack_public_path__ + "static/media/webs-purple.465cab35.svg";